import React, { useEffect, useState, useCallback, useMemo } from 'react'
import { Box, Typography, Divider, Paper, Grid, Card, CardContent, CardActions, Button, TextField, SpeedDial } from '@mui/material';
import Modal from 'components/Modal';
import { useSnackbar } from 'notistack';
import LibrarySelect from 'components/librarySelect';
import UpdateExpense from './UpdateExpense';
import { useSearchParams } from 'react-router-dom';
import { parse } from 'date-fns';
import MobileDateRangePicker from '@mui/lab/MobileDateRangePicker';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import { deleteExpense, getExpenseDetails, getExpensesByDate } from 'services/expenses';
import { getConstDbFormat } from 'utils/common';
import { getDisplayDate } from 'services/commonServices';
import CurrencyRupee from '@mui/icons-material/CurrencyRupee';
import AddIcon from '@mui/icons-material/Add';
import useConfirm from 'core/hooks/useConfirm';

const Expenses = () => {

  const [searchParams] = useSearchParams();
  const libraryId = searchParams.get('libraryId');
  const defaultFilterDates = useMemo(() => {
    if( searchParams ){
      const fromString = searchParams.get('from'), toString = searchParams.get('to');
      let from, to;
      if(fromString && toString){
        try{
          from = parse(fromString, 'yyyy-MM-dd', new Date());
          to = parse(toString, 'yyyy-MM-dd', new Date());
          return [to,from]
        }catch(e){
        }
      }
    }
    return [new Date(), new Date()];
  }, [searchParams]);
  const [ filterDates, setFilterDates] = useState([...defaultFilterDates]);
  const [openModal, setOpenModal] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [expenses, setExpenses] = useState([]);
  const [expenseDetails, setExpenseDetails] = useState(null);
  const [librarySelected, setLibrarySelected] = useState({});
  const confirm = useConfirm();

  const onLibrarySelected = useCallback((lib) => {
    setLibrarySelected(lib);
  },[]);

  useEffect(() => {
    const [fromDate,  toDate] = filterDates;
    if(fromDate && toDate && librarySelected?.libraryId){
      getExpenseData();
    }
  }, [filterDates, librarySelected]);

  function onDateAccepted(data) {
    const [fromDate,  toDate] = data;
    if((fromDate && toDate)) {
      setFilterDates([...data]);
    }else{
      setFilterDates(null);
      enqueueSnackbar(`Select ${fromDate === null ? 'From Date' : 'To Date'}`, {variant: 'error'});
    }
  }

  const onModalClose = useCallback(
    () => {
      setOpenModal(false);
      setExpenseDetails({})
    },
    [setOpenModal],
  )

  function getExpenseData() {
    const [fromDate,  toDate] = filterDates;
    const reqData = {
      fromDate: getConstDbFormat(fromDate),
      toDate: getConstDbFormat(toDate),
      propertyId: librarySelected?.libraryId,
      propertyType: 'LIBRARY'
    };

    getExpensesByDate({...reqData}).then(({response, error}) => {
      if(response){
        setExpenses([...response]);
      } else {
        setExpenses([]);
        enqueueSnackbar((response?.message || error), {variant: 'error'});
      }
    });
  }


  const onUpdateButtonClick = (e, expinseId) => {
    getExpenseDetails({}, null, expinseId).then(({response, error}) => {
      if(response){
        setExpenseDetails({...response});
        setOpenModal(true);
      } else {
        setExpenseDetails({});
        setOpenModal(false);
        enqueueSnackbar((response?.message || error), {variant: 'error'});
      }
    });
  }


  const onDeleteButtonClick = (e, expinseId) => {
    confirm({ title: 'Delete Pass?', description: 'Are you sure you want to delete this pass?' })
    .then(() => { 
      deleteExpenseData(expinseId);
    })
  }
  
  function deleteExpenseData(expinseId) {
    deleteExpense({}, null, expinseId).then(({response, error}) => {
      if(response){
        enqueueSnackbar("Expense deleted successfully", {variant: 'error'});
        getExpenseData();;
      } else {
        enqueueSnackbar((response?.message || error), {variant: 'error'});
      }
    });
  }
  
  const onExpenseUpdated = () => {
    setExpenseDetails({});
    setOpenModal(false);
    getExpenseData();
  };

  const onAddExpenseBtnClick = () => {
    setOpenModal(true);
  };

  return (
    <Paper sx={{ minWidth: 275, py: 2, px: 3, minHeight: "calc(100vh - 100px )" }}>
      <Box noValidate  sx={{ mt: 2 }} >
        <Grid container columnSpacing={4} rowSpacing={4} >
          <Grid item xs={12} sm={12} md={12} xl={12} lg={12}>
            <Typography component="h2" variant="h6" color="typography.heading"  gutterBottom sx={{mb: 1}}>
              Expenses
            </Typography>
          </Grid>
         
        </Grid>
        <Divider />
        <Grid container columnSpacing={4} rowSpacing={4} sx={{mt: 1 }}  justifyContent="flex-start" >
          <Grid container item xs={12} sm={12} md={12} xl={12} lg={12} sx={{ p: '0.8rem !important', ml:4, bgcolor: "#f3f3f3"}}>
            <Grid item xs={12} sm={12} md={12} xl={12} lg={12}  >
              <Typography variant="subtitle2"  component="div">
              Filters
              </Typography>
            </Grid>
            <Grid item xs={12} sm={12} md={6} xl={6} lg={6}  sx={{mt: 1.4}}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <MobileDateRangePicker
                  startText="From Date"
                  endText="To Date"
                  value={filterDates}
                  // onError = {onDateError}
                  inputFormat="dd/MM/yyyy"
                  // clearable={true}
                  onChange={(newValue) => {
                    return newValue;
                  }}
                  onAccept={(data) => onDateAccepted(data)}
                  renderInput={(startProps, endProps) => (
                    <React.Fragment>
                      <TextField {...startProps} size="small" onKeyDown={(e) => {e.preventDefault();return false}}/>
                      <Box sx={{ mx: 2 }}> to </Box>
                      <TextField {...endProps} size="small" onKeyDown={(e) => {e.preventDefault();return false}} />
                    </React.Fragment>
                  )}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={12} sm={12} md={6} xl={6} lg={6}  sx={{mt: 1.4, display: 'flex',justifyContent: {md: 'end'}}}>
              <LibrarySelect variant="outlined" onLibrarySelected={onLibrarySelected} defaultSelectId={libraryId} />
            </Grid>
          </Grid>
          
          {expenses.map((expense, index) =>(
            <Grid item xs={12} sm={6} md={6} xl={3} lg={4} key={index}>
              <Card sx={{ maxWidth: 345 }}>
                <CardContent sx={{py: 1}}>
                  <Typography variant="caption" color="text.secondary">
                    {getDisplayDate(expense.date)}
                  </Typography>
                  <Typography gutterBottom variant="h6" component="div" noWrap color="secondary">
                    <CurrencyRupee sx={{verticalAlign: 'middle'}} />{expense.amount}
                  </Typography>
                  <Typography  variant="subtitle2" component="div" noWrap>
                    {expense.type}
                  </Typography>
                  <Typography gutterBottom variant="caption" component="div" noWrap>
                    {expense.comments}
                  </Typography>
                </CardContent>
                <CardActions sx={{justifyContent: 'space-between', backgroundColor: '#f8f8f8'}}>
                  <Button size="small" color="info"  sx={{textTransform: 'none'}} onClick={(e) => onUpdateButtonClick(e, expense.id)}>
                    Update
                  </Button>
                  <Button size="small" color="error"  sx={{textTransform: 'none'}} onClick={(e) => onDeleteButtonClick(e, expense.id)}>
                    Delete
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
      <SpeedDial
        onClick={onAddExpenseBtnClick}
        ariaLabel="Add Pass"
        sx={{ position: 'absolute', bottom: 75, right: 75 }}
        icon={<AddIcon />}
        />
      <Modal maxWidth={"sm"} open={openModal} onModalClose={onModalClose} title={expenseDetails ? "Expense Details":"Add Expense"}>
        <UpdateExpense  expenseDetails={expenseDetails} onExpenseUpdated={onExpenseUpdated} libraryId={libraryId}/>
      </Modal>
    </Paper>
  );
}
 
export default Expenses;
